import { TrackByFunction } from '@angular/core';
import { get, isNil } from 'lodash';

import { logger } from '@assess/shared/logger';

const notFound = (item: any, property: string) =>
  logger.warn({ context: 'trackBy', data: { item, property } }, 'Property not found');

const by = (property: string): TrackByFunction<any> => {
  return (_index: number, item: Record<string, any>) => {
    const id = item[property];

    if (isNil(id)) {
      notFound(item, property);
    }

    return id;
  };
};

export const byMany: any = (properties: string[]) => {
  return (index: number, item: Record<string, any>) =>
    properties.reduce((acc, prop) => `${acc}${by(prop)(index, item)}`, '');
};

const byDotPath = (dotPath: string): TrackByFunction<any> => {
  return (_index: number, item: Record<string, any>) => {
    const value = get(item, dotPath);
    if (isNil(value)) {
      notFound(item, dotPath);
    }

    return value;
  };
};

export const trackByFunctions = {
  by,
  byDotPath,
  byMany,
  byIndex: (index: number) => index,
  byId: by('id'),
  byAtId: by('@id'),
  byKey: by('key'),
  byValue: by('value'),
};
